import { render, staticRenderFns } from "./safetyActivityInfo.vue?vue&type=template&id=2fe825c8&scoped=true"
import script from "./safetyActivityInfo.vue?vue&type=script&lang=js"
export * from "./safetyActivityInfo.vue?vue&type=script&lang=js"
import style0 from "./safetyActivityInfo.vue?vue&type=style&index=0&id=2fe825c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe825c8",
  null
  
)

export default component.exports